import { SettingsIcon } from "lucide-react";

import { Input } from "@/components/ui/input";

export const ChatSettingInput = ({ placeholder }: { placeholder?: string }) => (
  <div className="relative flex-1">
    <div className="relative w-full">
      <SettingsIcon className="absolute left-3 top-2.5 h-4 w-4 text-gray-400" />

      <Input
        type="text"
        disabled
        placeholder={placeholder || "Editing disabled"}
        readOnly
        className={`min-w-[150px] cursor-pointer truncate pl-9 pr-8 font-mono transition-colors hover:bg-gray-50 `}
      />
    </div>
  </div>
);
